<template>
	<div>
		<div class="pg-breadcrumb">
			<div class="breadcrumb-item em">优惠券</div>
			<div class="breadcrumb-item">优惠券兑换列表</div>
		</div>
		<div class="card-block">
			<Form inline class="pg-form-inline">
				<FormItem>
					<Input size="small" placeholder="兑换码" v-model="form.coupon_code" clearable></Input>
				</FormItem>
				<FormItem>
					<label class="input-label">状态</label>
					<Select size="small" placeholder="状态" v-model="form.is_used">
						<Option value="">请选择</Option>
						<Option value="0">未核销</Option>
						<Option value="1">已核销</Option>
						<Option value="2">已过期</Option>
					</Select>
				</FormItem>
				<FormItem>
					<label class="input-label">核销方</label>
					<Select size="small" placeholder="核销方" v-model="form.seller_id">
						<Option value="">请选择</Option>
						<Option :value="item.id" v-for="(item,index) in saless" :key="index">{{item.seller_name}}</Option>
					</Select>
				</FormItem>
				<FormItem>
					<label class="input-label">选择时间</label>
					<DatePicker type="datetime" size="small" clearable
											placeholder="起始日期" value-format="yyyy-MM-dd hh:mm:ss" :editable="false"
											v-model="form.start_time"></DatePicker>
					<DatePicker type="datetime" size="small" clearable
											placeholder="結束日期" value-format="yyyy-MM-dd hh:mm:ss" :editable="false"
											v-model="form.end_time"></DatePicker>
				</FormItem>
				<FormItem>
					<div class="pg-btn-wrap">
						<div class="pg-btn style1" @click="getCalseList">搜索</div>
					</div>
				</FormItem>
			</Form>

			<Table row-key="id" ref="selection" :columns="table.columns" :data="table.data" border>
				<template slot-scope="{ row, index }" slot="users">
					<span v-if="row.ltuser">{{ row.ltuser.user_name }}</span>
				</template>
				<template slot-scope="{ row, index }" slot="users2">
					<span v-if="row.ltuser">{{ row.ltuser.phone }}</span>
				</template>
				<template slot-scope="{ row, index }" slot="yarch">
					<span v-if="row.commodity_info">{{ row.commodity_info.order_name }}</span>
				</template>
				<template slot-scope="{ row, index }" slot="yarchs">
					<span v-if="row.commodity_info">{{ row.commodity_info.price }}</span>
				</template>
				<template slot-scope="{ row, index }" slot="status">
					<span v-if="row.is_used">{{ row.is_used == 0 ? '未核销': row.is_used == 1 ? '已核销' : '已过期' }}</span>
				</template>
				<template slot-scope="{ row, index }" slot="start_time">
					<span v-if="row.release_time">{{ filterTime(row.release_time * 1000) }}</span>
				</template>
				<template slot-scope="{ row, index }" slot="end_time">
					<span v-if="row.release_time">{{ filterTime(row.close_time * 1000) }}</span>
				</template>
<!--				<template slot-scope="{ row, index }" slot="action">
					<div class="pg-btn-wrap">
						<div class="pg-btn style2" @click="handleShowModal('edit',row)">修改</div>
						<div class="pg-btn style1" @click="handleDEL(row)">刪除</div>
					</div>
				</template>-->
			</Table>
			<div class="pg-pagger">
				<Page :total="total" show-total show-sizer @on-change="changePage" @on-page-size-change="onpagesizechange" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			form: {
				seller_id: '',
				coupon_code: '',
				is_used: '',
				start_time: '',
				end_time: ''
			},
			table: {
				columns: [
					{
						title: '兑换码',
						tree: true,
						key: 'coupon_code'
					},{
						title: '用户名称',
						tree: true,
						slot: 'users'
					}, {
						title: '用户账号',
						action: true,
						slot: 'users2'
					},{
						title: '优惠券名称',
						action: true,
						slot: 'yarch'
					},{
						title: '优惠券金额',
						action: true,
						slot: 'yarchs'
					},{
						title: '优惠券状态',
						action: true,
						slot: 'status'
					},{
						title: '开始时间',
						action: true,
						slot: 'start_time'
					},{
						title: '结束时间',
						action: true,
						slot: 'end_time'
					},
					// {
					// 	title: '操作',
					// 	action: true,
					// 	slot: 'action'
					// }
				],
				data: [],
			},
			saless: [],
			limit: 10,
			page: 1,
			total: 0
		}
	},
	created() {
		this.getList();
	},
	methods: {
		changePage(val) {
			console.log(val)
			this.page = val
			this.getCalseList()
		},
		onpagesizechange(val) {
			console.log(val)
			this.limit = val
			this.page = 1;
			this.getCalseList()
		},
		filterTime(val) {
			const dateObj = new Date(val);
			return `${dateObj.getFullYear()}-${(dateObj.getMonth() + 1).toString().padStart(2, "0")}-${dateObj.getDate().toString().padStart(2, "0")} ${dateObj.getHours().toString().padStart(2, "0")}:${dateObj.getMinutes().toString().padStart(2, "0")}:${dateObj.getSeconds().toString().padStart(2, "0")}`;
		},
		getCalseList() {
			const start_time = this.$Utils.formatDate(this.form.start_time)
			const end_time = this.$Utils.formatDate(this.form.end_time)
			const data = {
				...this.form,
				start_time,
				end_time,
				limit:  this.limit,
				page: this.page,
			}
			this.$Rq.requestAuth({
				url: this.$Api.salesList2,
				method: 'get',
				data
			}).then((res) => {
				console.log(res)
				if (res.list.data) {
					this.table.data = res.list.data
					this.total = res.list.total
				} else {
					this.table.data = []
				}
			})
		},
		// 获取列表
		getList() {
			this.$Rq.requestAuth({
				url: this.$Api.salesList,
				method: 'get'
			}).then((res) => {
				console.log(res)
				if (res.list.length) {
					this.saless = res.list
				} else {
					this.saless = []
				}
			})
		},
	}
}
</script>

<style scoped lang="scss">
.card-block {
	background-color: #FFFFFF;
	border-radius: 4px;
	padding: 15px;
}

.table-box {
	background-color: #FFFFFF;
	padding: 10px;
}

.add {
	padding: 20px 0;
}

.pg-btn-wrap {
	display: flex;
	align-items: center;

	.pg-btn {
		display: inline-block;
		vertical-align: middle;
		width: 120px;
		height: 35px;
		line-height: 35px;
		background: #fff;
		text-align: center;
		font-size: 14px;
		color: #999999;
		cursor: pointer;
		margin-right: 20px;
		text-decoration: none;
		border-radius: 3px;
		box-shadow: 0 2px 4px rgba(153, 153, 153, 0.5);
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;

		&:last-of-type {
			margin-right: 0;
		}

		&.style1 {
			color: #fff;
			background: rgba(255, 101, 101, 1);
			box-shadow: 0 2px 4px rgba(255, 101, 101, 0.5);
		}

		&.style2 {
			color: #fff;
			background: rgba(101, 132, 255, 1);
			box-shadow: 0 2px 4px rgba(101, 132, 255, 0.5);
		}

		&.style3 {
			color: #fff;
			background: #FF9A65;
			box-shadow: 0 2px 4px rgba(255, 154, 101, 0.5);
		}
	}

	.loading-btn {
		height: 35px;
		cursor: not-allowed;
		opacity: 0.9;
	}
}
</style>
